import { WrapperCtx } from "App/Component/layout/Wrapper/context/context";
import { RT_INPUT_REKAP_TAGIHAN } from "App/constants";
import { isNull } from "App/utils/helpers";
import React, { createContext, useEffect, useState, useContext } from "react";
import { RESET_STATE_REKAP_TAGIHAN, STATE_FILTER_TAGIHAN } from "../ui";

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const { state } = useContext(WrapperCtx);
  const [formError, setFormError] = useState(null);
  const [rowsTagihan, setRowsTagihan] = useState([]);
  const [totalDataTagihan, setTotalDataTagihan] = useState(0);
  const [totalDataPembayaran, setTotalDataPembayaran] = useState(0);
  const [rowsPembayaran, setRowsPembayaran] = useState([]);
  const [rowsSelect, setRowsSelect] = useState([]);
  const [rowsLog, setRowsLog] = useState([]);
  const [formFilterTagihan, setFormFilterTagihan] =
    useState(STATE_FILTER_TAGIHAN);

  const [formData, setFormData] = useState(RESET_STATE_REKAP_TAGIHAN);

  useEffect(() => {
    if (isNull(state.page_input_rekap_tagihan)) {
      setFormData(RESET_STATE_REKAP_TAGIHAN);
    } else {
      if (state.wrapper_active_menu === RT_INPUT_REKAP_TAGIHAN) {
        setFormData(state.page_input_rekap_tagihan.formData);
        setRowsTagihan(state.page_input_rekap_tagihan.detail);
        setTotalDataTagihan(state.page_input_rekap_tagihan.totalDataTagihan);
        setTotalDataPembayaran(
          state.page_input_rekap_tagihan.totalDataPembayaran
        );
        setRowsPembayaran(state.page_input_rekap_tagihan.pembayaran);
        setFormError(null);
        setRowsSelect([]);
      } else {
        setFormData(RESET_STATE_REKAP_TAGIHAN);
        setFormError(null);
        setRowsSelect([]);
      }
    }
  }, [state.page_input_rekap_tagihan]); // eslint-disable-line

  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        formError,
        setFormError,
        rowsTagihan,
        setRowsTagihan,
        rowsPembayaran,
        setRowsPembayaran,
        rowsSelect,
        setRowsSelect,
        rowsLog,
        setRowsLog,
        totalDataTagihan,
        setTotalDataTagihan,
        totalDataPembayaran,
        setTotalDataPembayaran,
        formFilterTagihan,
        setFormFilterTagihan,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
